import {
    Bold, ContentButton,
    ContentDescription, ContentSubDescription,
    ContentSubTitle, Description, StatusSubscription, SubTitle
} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/styled";
import ButtonMain from "@dropDesk/presentation/components/buttons/button_main";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {formatCurrency} from "@dropDesk/utils/helpers/common";
import {PaymentSubscriptionEntity} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_entity";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";

const DowngradePlan = (
    {
        disabled,
        loading,
        onClickCancelFutureSubscription,
        planName,
        nextDueDateDDMMYYYY,
        planValue,
        visibleCancelButton,
        oldSubs,
        quantityUsersNewSubs
    }: {
        disabled: boolean;
        loading: boolean;
        onClickCancelFutureSubscription: () => void
        planName: string
        nextDueDateDDMMYYYY: string
        planValue: number
        visibleCancelButton: boolean
        quantityUsersNewSubs: number,
        oldSubs?: PaymentSubscriptionEntity
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <>
            <ContentDescription>
                <ContentSubTitle>
                    <SubTitle color={colors.text}>{planName}</SubTitle>
                    <StatusSubscription
                        background={SharedColors.onAttendingStatus}
                        color={SharedColors.textAttendingStatus}
                    >Downgrade agendado</StatusSubscription>
                </ContentSubTitle>
                <ContentSubDescription>
                    <Description size={15} color={colors.text}>Próxima cobrança:
                        <Bold>&nbsp;{nextDueDateDDMMYYYY}</Bold></Description>
                    <Description size={15} color={colors.text}>Valor:
                        <Bold>&nbsp;{formatCurrency(planValue)}</Bold></Description>
                    {oldSubs && <Description size={15} color={colors.text}>Plano em vigor:
                        <Bold>&nbsp;O plano em vigor é {oldSubs.planName} até dia {nextDueDateDDMMYYYY}, após
                            isso
                            entrará em vigor o downgrade e sua quantidade de usuário será reduzida
                            de {oldSubs.quantityOfUsers} para {quantityUsersNewSubs}.</Bold></Description>}
                </ContentSubDescription>
            </ContentDescription>
            {visibleCancelButton && <ContentButton>
                <ButtonMain
                    style={{paddingLeft: 5, paddingRight: 5}}
                    widthPercentage={100}
                    letterFontSize={15}
                    disabled={disabled}
                    loading={loading}
                    height={35}
                    color={colors.accent}
                    type={"submit"}
                    letter={'Desfazer troca de plano'}
                    onClick={() => onClickCancelFutureSubscription()}
                />
            </ContentButton>}
        </>
    )
}
export default DowngradePlan;
